import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const exportToPDFQuestions = (filteredData) => {
  const doc = new jsPDF();
  
  doc.setFontSize(16);
  doc.text('Checklist Questions Report', 14, 15);
  
  const tableData = filteredData.map(question => [
    question.question,
    question.order,
    question.service_type,
    question.input_type,
    question.active ? 'Active' : 'Inactive'
  ]);
  
  doc.autoTable({
    head: [['Question', 'Order', 'Service Type', 'Input Type', 'Status']],
    body: tableData,
    startY: 25,
    theme: 'grid',
    styles: { 
      fontSize: 9,
      cellPadding: 3
    },
    headStyles: {
      fillColor: [66, 139, 202],
      textColor: [255, 255, 255]
    },
    columnStyles: {
      0: { cellWidth: 60 }, // Question column
      1: { cellWidth: 20 }, // Order column
      2: { cellWidth: 35 }, // Service Type column
      3: { cellWidth: 35 }, // Input Type column
      4: { cellWidth: 25 }  // Status column
    }
  });
  
  doc.save('checklist_questions.pdf');
};